import React from 'react';
import './ProfileHeader.css';

const ProfileHeader = ({ user }) => {
  const getInitials = () => {
    const firstName = user?.first_name || '';
    const lastName = user?.last_name || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  const getFullName = () => {
    return `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User';
  };

  return (
    <div className="profile-header">
      <div className="profile-header__avatar">
        <span className="profile-header__initials">{getInitials()}</span>
      </div>
      <div className="profile-header__info">
        <h1 className="profile-header__name">{getFullName()}</h1>
        <p className="profile-header__role">{user?.role_name ? user.role_name.charAt(0).toUpperCase() + user.role_name.slice(1) : 'User'}</p>
        <p className="profile-header__email">{user?.email || ''}</p>
        {user?.contract_signed_pdf_url && (
          <a
            className="profile-header__contract-link"
            href={user.contract_signed_pdf_url}
            target="_blank"
            rel="noreferrer"
          >
            View signed contract
          </a>
        )}
      </div>
      <div className="profile-header__status">
        <div className={`profile-header__badge ${user?.is_verified_by_admin ? 'profile-header__badge--verified' : 'profile-header__badge--pending'}`}>
          {user?.is_verified_by_admin ? 'Verified' : 'Pending Verification'}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;










